module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "wrap"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("日志管理")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "wrap-main",
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.rows
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "用户",
      "prop": "username"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "operation"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用时",
      "prop": "time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作时间",
      "prop": "gmtCreate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "方法",
      "prop": "method"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ip",
      "prop": "ip"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.remove(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": _vm.limit,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.search
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fbfbc2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/log/List.vue
// module id = 1180
// module chunks = 2